import { DEFAULT_LANGUAGE, Language } from '@/Config/languages';

export const defaultLanguage = (): Language => DEFAULT_LANGUAGE;
